import refs from '../helpers/refs'
import site from '../helpers/site'

class MIngredients {
  constructor (el) {
    this.site = site()

    this.share = el
    this.$refs = refs(this.share)

    // New functionality for Char-Griller
    if (this.site === 'chargriller') {
      this.initSlider()
    }
  }

  initSlider () {
    this.servesSlider = document.querySelector('.m-ingredients__serves-slider-input')
    this.servesOutput = document.getElementById('serves-output')
    this.originalServes = this.servesSlider.value
    this.servesSlider.addEventListener('input', () => this.handleSliderChange())

    // Look for data-serves
    const serves = document.querySelector('[data-serves]')
    if (serves) {
      this.originalServes = Number(serves.dataset.serves)
      // Set the slider to the original serves
      this.servesSlider.value = this.originalServes
      // Set the max value of the slider
      this.servesSlider.max = ((this.originalServes < 4) ? this.originalServes * 3 : this.originalServes * 2)
      // Set the min value of the slider
      this.servesSlider.min = 0
      // Set display value
      this.servesOutput.innerText = this.originalServes
    }

    // Save the original parsed ingredients
    this.originalIngredients = this.parseAllIngredients()
  }

  handleSliderChange () {
    const servesNow = this.originalServes
    let servesAfter = Number(this.servesSlider.value)

    if (this.servesSlider.value === '0') {
      this.servesSlider.value = 1
      servesAfter = 1
    }

    this.servesOutput.innerText = servesAfter
    const updatedRecipe = this.adjustRecipe(servesNow, servesAfter)
    this.updateHTML(updatedRecipe)
  }

  parseIngredient (ingredientText) {
    const parsed = ingredientText.match(/((\d+\s)?\d*[/.\d]*|[\u2150-\u2189]+)\s+(.*)/)

    if (parsed === null) {
      throw new Error('Unable to parse ingredient: ' + ingredientText)
    }

    const amount = this.fractionToDecimal(parsed[1])

    if (isNaN(amount)) {
      return {
        amount: 0,
        ingredient: ingredientText
      }
    }

    return {
      amount, // Save the amounts as a number, not a string
      ingredient: parsed[3] ?? parsed[2]
    }
  }

  // Add a new function to parse all ingredients on initialization
  parseAllIngredients () {
    const ingredients = document.querySelectorAll('.m-ingredients__item-text')
    return Array.from(ingredients, (ingredient) => {
      try {
        return this.parseIngredient(ingredient.innerText)
      } catch (e) {
        console.warn(e)
        return null
      }
    }).filter(ingredient => ingredient !== null)
  }

  updateHTML (ingredients) {
    const ingredientElems = document.querySelectorAll('.m-ingredients__item-text')

    // Iterate through the ingredients, figure out which amount to use based on matching the text
    ingredients.forEach((ingredient) => {
      // Filter to get all matching elements
      const ingredientElemsArray = Array.from(ingredientElems).filter((elem) => {
        return elem.innerText.includes(ingredient.ingredient)
      })

      // If matching elements are found, update each one of them
      if (ingredientElemsArray.length) {
        ingredientElemsArray.forEach((ingredientElem) => {
          const amount = ingredient.amount !== 0 ? this.decimalToFraction(ingredient.amount) : 0
          ingredientElem.innerText = `${amount || ''} ${ingredient.ingredient}`
        })
      }
    })
  }

  adjustRecipe (servesNow, servesAfter) {
    const ratio = servesAfter / servesNow
    return this.originalIngredients.map((ingredient) => {
      // Clone the ingredient to not mutate the original data
      const adjustedIngredient = { ...ingredient }
      adjustedIngredient.amount *= ratio

      if (!isNaN(adjustedIngredient.amount)) {
        // if the amount is not NaN, return the adjusted ingredient
        return adjustedIngredient
      } else {
        // Otherwise, return the original ingredient
        return ingredient
      }
    })
  }

  fractionToDecimal (fractionStr) {
    // Handle combined numbers and fractions e.g., "2 1/2"
    const parts = fractionStr.split(' ')
    let decimal = 0
    if (parts.length > 1) {
      decimal += parseFloat(parts[0])
      fractionStr = parts[1]
    } else {
      fractionStr = parts[0]
    }

    // Handle standalone fractions e.g., "1/2"
    if (fractionStr.includes('/')) {
      const [numerator, denominator] = fractionStr.split('/').map(Number)
      decimal += numerator / denominator
    } else {
      decimal += parseFloat(fractionStr)
    }

    return decimal
  }

  decimalToFraction (decimal) {
    const WHOLE = Math.floor(decimal)
    const REMAINDER = decimal - WHOLE
    const EPSILON = 0.1 // Precision to determine closeness to a value

    // If remainder is nearly 0, just return the whole number
    if (Math.abs(REMAINDER) < EPSILON) {
      if (WHOLE === 0) {
        return 'Less than 1/8'
      }

      return WHOLE.toString()
    }

    let numerator
    let denominator
    const closestFraction = fraction => Math.abs(REMAINDER - fraction) < EPSILON

    if (closestFraction(1 / 8)) {
      [numerator, denominator] = [1, 8]
    } else if (closestFraction(1 / 4)) {
      [numerator, denominator] = [1, 4]
    } else if (closestFraction(1 / 3)) {
      [numerator, denominator] = [1, 3]
    } else if (closestFraction(1 / 2)) {
      [numerator, denominator] = [1, 2]
    } else if (closestFraction(2 / 3)) {
      [numerator, denominator] = [2, 3]
    } else if (closestFraction(3 / 4)) {
      [numerator, denominator] = [3, 4]
    } else if (closestFraction(7 / 8)) {
      [numerator, denominator] = [7, 8]
    } else {
      // If the REMAINDER doesn't closely match any common fractions, return the decimal to 2 places
      const decimal = WHOLE ? `${WHOLE} ${REMAINDER.toFixed(2)}` : REMAINDER.toFixed(2)

      return decimal
    }

    return WHOLE ? `${WHOLE} ${numerator}/${denominator}` : `${numerator}/${denominator}`
  }
}

window.addEventListener('load', () => {
  document.querySelectorAll('.m-ingredients').forEach(el => new MIngredients(el))
})
